import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ShapeDropIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.0995 6.09676C16.2748 10.5794 16.7589 11.9727 16.7589 13.7153C16.7589 16.2113 14.6252 18.32 12.0995 18.32C9.57377 18.32 7.44 16.2113 7.44 13.7153C7.44 11.9727 7.92412 10.5794 12.0995 6.09676ZM12.0995 4C6.84005 9.49683 6 11.2865 6 13.7153C6 16.9842 8.79406 19.76 12.0995 19.76C15.4049 19.76 18.1989 16.9842 18.1989 13.7153C18.1989 11.2865 17.3589 9.49683 12.0995 4Z" />
    </SvgIcon>
  );
});
